import type { ISiteDispatch } from '@/types/eos/SiteDispatches'
import type { ISiteDispatchFilters } from '@/types/eos/filters'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getSiteDispatches(filters: ISiteDispatchFilters): Promise<IPage<ISiteDispatch>> {
  const res = await axios.get(import.meta.env.VITE_APP_SITE_DISPATCHES_ENDPOINT, {
    params: filters,
  })
  return res.data
}

export async function deleteSiteDispatchCurtailmentPlan(
  siteDispatchID: number,
  curtailmentPlanID: number
): Promise<void> {
  await axios.delete(
    `${import.meta.env.VITE_APP_SITE_DISPATCHES_ENDPOINT}/${siteDispatchID}/curtailment-plans/${curtailmentPlanID}`
  )
}
